module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-560.5d5ef9c.woff2";